import { Flex, Input, Text } from '@chakra-ui/react'
import React, { useMemo, useState } from 'react'
import { useModalState } from '~/atoms/ModalState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'

import { useNewParkingLotModalStyle } from './componentStyles/NewParkingLotModal.style'

const parkingLotList = [
  {
    id: 1,
    label: 'Parking 1',
    targetNumber: '5901',
  },
  {
    id: 2,
    label: 'Parking 2',
    targetNumber: '5902',
  },
  {
    id: 3,
    label: 'Parking 3',
    targetNumber: '5903',
  },
  {
    id: 4,
    label: 'Parking 4',
    targetNumber: '5904',
  },
  {
    id: 5,
    label: 'Parking 5',
    targetNumber: '5905',
  },
  {
    id: 6,
    label: 'Parking 6',
    targetNumber: '5906',
  },
  {
    id: 7,
    label: 'Parking 7',
    targetNumber: '5907',
  },
  {
    id: 8,
    label: 'Parking 8',
    targetNumber: '5908',
  },
  {
    id: 9,
    label: 'Parking 9',
    targetNumber: '5909',
  },
  {
    id: 10,
    label: 'Parking 10',
    targetNumber: '5910',
  },
]

export const NewParkingLotModal = () => {
  const [selectedParkingLotIndex, setSelectedParkingLotIndex] =
    useState<number>(0)
  const [labelText, setLabelText] = useState<string | undefined>(undefined)

  const {
    parkingModal: [parkingModalState, setParkingModalState],
  } = useModalState()
  const { pbxId } = useUserState()
  const {
    settings: {
      pbx: { parkingLots },
    },
    addParkingLot,
  } = useSettingsState(pbxId)

  // Get the parking lots from 'parkingLotList' that are not already in 'parkingLots'
  const availableParkingLots = useMemo(() => {
    return parkingLotList.filter(
      (parkingLot) => !parkingLots?.find((lot) => lot.id === parkingLot.id),
    )
  }, [parkingLots])

  const selectedParkingLot = availableParkingLots[selectedParkingLotIndex]

  const handleParkingSelect = (id: number, index: number) => {
    setSelectedParkingLotIndex(index)
  }
  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLabelText(e.target.value)
  }

  const handleClose = () => {
    setParkingModalState({ open: false })
    setLabelText(undefined)
    setSelectedParkingLotIndex(0)
  }
  const handleSave = () => {
    const label = labelText ?? selectedParkingLot.label
    addParkingLot({
      id: selectedParkingLot.id,
      label,
      defaultLabel: selectedParkingLot.label,
      targetNumber: selectedParkingLot.targetNumber,
    })
    handleClose()
  }

  const styles = useNewParkingLotModalStyle()

  return (
    <MangoModal
      isOpen={parkingModalState.open}
      onClose={handleClose}
      header="Add Parking Spot"
      body={
        <Flex sx={styles.bodyContainer}>
          <Flex sx={styles.dropdownContainer}>
            <Text sx={styles.dropdownLabel}>Parking Spot</Text>
            <DropdownSelect
              items={availableParkingLots.map((lot) => {
                return { value: lot.id, content: lot.label }
              })}
              selectedIndex={selectedParkingLotIndex}
              onSelect={handleParkingSelect}
            />
          </Flex>
          <Flex sx={styles.inputContainer}>
            <Text sx={styles.inputLabel}>Label</Text>
            <Input
              variant="mango"
              placeholder={selectedParkingLot.label}
              value={labelText}
              onChange={handleLabelChange}
            />
          </Flex>
        </Flex>
      }
      footer={
        <Flex sx={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            Cancel
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleSave}
          >
            Save
          </MangoButton>
        </Flex>
      }
    ></MangoModal>
  )
}
